import React,{Component} from 'react'
import {connect} from "react-redux"
import Switch from "react-switch";


class Filters extends Component{
    componentDidMount(){
        let {data} = this.props;

    }

    handleOnBindingTypeChange(e){
        this.handleFieldChange("bindingType",e.target.value)
    }
    handleFieldChange(field,value){
        let {data} = this.props
        let filters = {
            ...data,
            [field]:value
        }
        this.funcThrowFilters(filters);
    }
    handleFileChange(e){

        this.handleFieldChange("file",e.target.files[0]);
    }
    

    handleOnReset() {
        this.file.value = "";
        if (this.props.onReset) {
            this.props.onReset();
        }
    }

    funcThrowFilters(filters) {
        if (this.props.onFiltersChange) {
            this.props.onFiltersChange(filters);
        }
    }

    render(){
        let {data,config} = this.props

        let filename =( data.file &&  data.file !== null) ? data.file.name : "Файл не выбран"
        
        return(
            <div className="c-filters">
                <div className="row">
                    {
                        config.bindingTypes != null?
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label>Привязанные товары: </label>

                                    <select className="select form-control" value={data.bindingType} onChange={(e) => this.handleOnBindingTypeChange(e)}>
                                        {
                                            config.bindingTypes.map((item,index)=>{
                                                return(
                                                    <option value={item.key} key={index}>{item.value}</option>
                                                    )

                                            })
                                        }
                                    </select>

                                </div>
                            </div>
                            :null

                    }



                    <div className="col-md-3">
                        <div className="form-group">
                            <label>Файл с артикулами: </label>
                            <div className="uploader">
                                <input type="file" className="file-styled"  onChange={(e)=>this.handleFileChange(e)} ref={(input)=>this.file = input}/>
                                <span className="filename" >{filename}</span>
                                <span className="action btn btn-default" >Выберите файл</span>
                            </div>
                        </div>
                    </div>

                    


                    <div className="col-md-3 filters-controls col-md-offset-3">
                        <div className="row">
                            <div className="col-sm-6">
                                {/* <button className="btn btn-submit" >Принять</button> */}
                            </div>
                            <div className="col-sm-6">
                                <button className="btn btn-reset" onClick={() => this.handleOnReset()}>Сбросить</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        )
    }

}
function mapStateToProps(state) {
    return{
        config:state.config,

    }
}



export default connect(mapStateToProps)(Filters);



// WEBPACK FOOTER //
// ./src/components/Company/Filters.jsx